import React, { useEffect, useState } from "react";
import {
    getTemplates,
    createTemplate,
    updateTemplate,
    deleteTemplate,
} from "../services/smsTemplateApi";
import "./SmsTemplatePage.css";

const SmsTemplatePage = () => {
    const [templates, setTemplates] = useState([]);
    const [form, setForm] = useState({
        templateCode: "",
        description: "",
        templateText: "",
        templateId: "",
    });
    const [editId, setEditId] = useState(null);

    const loadTemplates = async () => {
        const res = await getTemplates();
        setTemplates(res.data);
    };

    useEffect(() => {
        loadTemplates();
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        try {
            if (!form.templateCode || !form.templateText) {
                alert("Template Code & Text are required");
                return;
            }

            if (editId) {
                await updateTemplate(editId, form);
            } else {
                await createTemplate(form);
            }

            handleClear();
            loadTemplates();
        } catch (err) {
            alert(err.response?.data || "Error");
        }
    };

    const handleEdit = (item) => {
        setForm(item);
        setEditId(item.id);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Delete this template?")) {
            await deleteTemplate(id);
            loadTemplates();
        }
    };

    const handleClear = () => {
        setForm({
            templateCode: "",
            description: "",
            templateText: "",
            templateId: "",
        });
        setEditId(null);
    };

    return (
        <div className="page">

            {/* HEADER */}
            <div className="header-card">
                <h2>📄 SMS Template</h2>
                <p>Create and manage reusable SMS message templates</p>
            </div>

            {/* FORM CARD */}
            <div className="card">
                <div className="form-grid">
                    <div className="form-group">
                        <label>Template Code</label>
                        <input
                            name="templateCode"
                            value={form.templateCode}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <label>Template ID</label>
                        <input
                            name="templateId"
                            value={form.templateId}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group full-width">
                        <label>Description</label>
                        <input
                            name="description"
                            value={form.description}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group full-width">
                        <label>Template Text</label>
                        <textarea
                            name="templateText"
                            value={form.templateText}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="button-group">
                    <button className="button save" onClick={handleSubmit}>
                        {editId ? "Update" : "Create"}
                    </button>
                    <button className="button clear" onClick={handleClear}>
                        Clear
                    </button>
                </div>
            </div>

            {/* TABLE CARD */}
            <div className="card">
                <h3>📋 Template List</h3>

                <table className="table">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Description</th>
                            <th>Text</th>
                            <th>Template ID</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {templates.map((t) => (
                            <tr key={t.id}>
                                <td>{t.templateCode}</td>
                                <td>{t.description}</td>
                                <td className="truncate">{t.templateText}</td>
                                <td>{t.templateId}</td>
                                <td>
                                    <div className="action-buttons">
                                        <button onClick={() => handleEdit(t)}>Edit</button>
                                        <button onClick={() => handleDelete(t.id)}>Delete</button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SmsTemplatePage;